var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./TodayPunchStatisticsModal.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-720e0f8e\",\"hasScoped\":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./TodayPunchStatisticsModal.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/crm/TodayPunchStatisticsModal.vue
// module id = 1349
// module chunks = 8